import { useAppSelector } from "./redux";

/**
 * Hook pour vérifier les fonctionnalités disponibles pour l'utilisateur connecté
 */
export const useFeatures = () => {
  const { user } = useAppSelector((state) => state.auth);

  /**
   * Vérifie si l'utilisateur a accès à une fonctionnalité spécifique
   */
  const hasFeature = (feature: string): boolean => {
    if (!user) return false;

    return (
      JSON.stringify(
        user.enabledFeatures?.map((feature) => feature.toLowerCase()),
      )?.includes(feature.toLowerCase()) || false
    );
  };

  /**
   * Vérifie si l'utilisateur a accès à plusieurs fonctionnalités
   */
  const hasAnyFeature = (features: string[]): boolean => {
    if (!user) return false;
    return features.some((feature) => user.enabledFeatures?.includes(feature));
  };

  /**
   * Vérifie si l'utilisateur a accès à toutes les fonctionnalités
   */
  const hasAllFeatures = (features: string[]): boolean => {
    if (!user) return false;
    return features.every((feature) => user.enabledFeatures?.includes(feature));
  };

  /**
   * Retourne toutes les fonctionnalités disponibles pour l'utilisateur
   */
  const getAvailableFeatures = (): string[] => {
    if (!user) return [];
    return user.enabledFeatures || [];
  };

  return {
    hasFeature,
    hasAnyFeature,
    hasAllFeatures,
    getAvailableFeatures,
    user,
  };
};
